var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M476 480H324C304.118 480 288 463.882 288 444V96H192V252C192 271.882 175.882 288 156 288H32C14.327 288 0 273.673 0 256V256C0 238.327 14.327 224 32 224H128V68C128 48.118 144.118 32 164 32H316C335.882 32 352 48.118 352 68V416H448V260C448 240.118 464.118 224 484 224H608C625.673 224 640 238.327 640 256V256C640 273.673 625.673 288 608 288H512V444C512 463.882 495.882 480 476 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSquare);
export default __webpack_public_path__ + "static/media/wave-square.b3bc068337012534440f6c178927ba44.svg";
export { ForwardRef as ReactComponent };